module.exports = __webpack_public_path__ + "fonts/Calibre-Thin.faf54c73.woff";